module.exports = __webpack_public_path__ + "img/role1.3f664a30.gif";